module.exports = __webpack_public_path__ + "img/linkedin.b7baa1ab.svg";